var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNormal = function SvgNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 1.5,
    d: "M22.686 30.986H8.287a1.814 1.814 0 0 1-1.814-1.815V9.998c0-1.002.812-1.814 1.814-1.814h20.797c1.002 0 1.815.812 1.815 1.814v11.587M6.5 13.09h24.357"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M11.379 6.596v3.248M25.984 6.596v3.248"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E242F",
    stroke: "#1E242F",
    strokeWidth: 0.3,
    d: "M28.998 20.79a7.307 7.307 0 1 0 7.307 7.307 7.316 7.316 0 0 0-7.307-7.307Zm0 13.506a6.2 6.2 0 1 1 6.2-6.2 6.205 6.205 0 0 1-6.2 6.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M28.488 27.98V24.95M31.57 31.064l-3.078-3.095"
  })));
};
export default SvgNormal;